export const STEPS = [
    { key: 'welcome' },
    { key: 'practise' },
    { key: 'share' },
    { key: 'done' },
];
